import type { DateValue, Order, OrderedProduct } from "./types";
import { ORDER_STATUSES } from "./types";

export const money = (value = 0, currency = "BGN") =>
  new Intl.NumberFormat("bg-BG", { style: "currency", currency }).format(value);

export const dateTime = (value: DateValue) => {
  if (!value) return "—";
  const candidate = typeof value === "object" && "toDate" in value
    ? value.toDate()
    : new Date(value as string | number | Date);
  return Number.isNaN(candidate.getTime())
    ? "—"
    : new Intl.DateTimeFormat("bg-BG", { dateStyle: "medium", timeStyle: "short" }).format(candidate);
};

export const toDate = (value: DateValue) => {
  if (!value) return null;
  const candidate = typeof value === "object" && "toDate" in value
    ? value.toDate()
    : new Date(value as string | number | Date);
  return Number.isNaN(candidate.getTime()) ? null : candidate;
};

export const orderStatus = (status = 0) =>
  ORDER_STATUSES.find((entry) => entry.value === status) ?? ORDER_STATUSES[0];

export const orderItems = (order: Order): OrderedProduct[] => {
  if (Array.isArray(order.items) && order.items.length) return order.items;
  if (!order.products) return [];
  try {
    const parsed = JSON.parse(order.products);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const slugify = (value: string) => value
  .trim()
  .toLocaleLowerCase("bg-BG")
  .normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zа-я0-9]+/gi, "-")
  .replace(/^-+|-+$/g, "") || `item-${Date.now()}`;

export const compactId = (value: string) => value.length > 14 ? `${value.slice(0, 8)}…${value.slice(-4)}` : value;

export const cleanList = (value: string) => [...new Set(value
  .split(/[,\n]/)
  .map((entry) => entry.trim())
  .filter(Boolean))];

export const classNames = (...values: Array<string | false | null | undefined>) => values.filter(Boolean).join(" ");

